import { useEmailState } from 'components/EmailStateProvider';
import ModalComponent from 'components/Common/Modal';

export const RemoveRecipientsModal = (props) => {
  const { isOpen, setIsOpen, selectRef } = props;
  const { setEmailState } = useEmailState();

  return (
    <ModalComponent
      maxWidth={500}
      isOpen={!!isOpen}
      setIsOpen={setIsOpen}
      overlayClassName='react-modal-overlay report-extra-index-modal z-extra-max-plus'
    >
      <div className='p-3 px-lg-5 pt-lg-5 pb-lg-2'>
        <div className='text-center'>
          <p>Are you sure you want to remove all recipients?</p>

          <div className='my-4'>
            <button
              className='general-button main-danger-button rounded-pill text-white rounded-5 px-4 py-2'
              onClick={() => {
                setEmailState('emailSelectedContacts', []);
                selectRef.current.setValue([], 'set-value');
                setIsOpen(false);
              }}
            >
              Remove all recipients
            </button>
          </div>
        </div>
      </div>
    </ModalComponent>
  );
};
export default RemoveRecipientsModal;
